import React from 'react';
import { ButtonType } from '../../Buttons/Button/ButtonType';
import useScrollLock from '@hooks/useBodyScrollLock';
import SvgFilter from '@img/icons/filter.svg';
import SvgChevDown from '@img/icons/chevron-down-thin.svg';
import SvgClose from '@img/icons/x.svg';
import S from './SideFilter.styles';
import { withMotion } from '@hoc/withMotion';
const SideFilter = ({ activeSideFilter, checkboxFilters, sideDropDownFilter, sideDropDownFilterValue, sideFilterOpen, setSideFilterOpen, onCheckboxChange, onReset, submitSideFilter, }) => {
    const ref = React.useRef(null);
    const [activeId, setActiveId] = React.useState('');
    useScrollLock(ref.current, sideFilterOpen);
    return (React.createElement(S.Container, { "aria-active": sideFilterOpen },
        React.createElement(S.Overlay, { ref: ref },
            React.createElement(S.Close, { onClick: (event) => {
                    event.preventDefault();
                    setSideFilterOpen && setSideFilterOpen(false);
                } },
                React.createElement(SvgClose, null),
                React.createElement("span", null, "Close")),
            React.createElement(S.FilterList, null,
                React.createElement(S.Title, null, "Filters:"),
                React.createElement(S.ActiveFilters, null,
                    checkboxFilters?.map((filter) => (activeSideFilter &&
                        activeSideFilter[filter.key] &&
                        activeSideFilter[filter.key]?.map((item) => (filter.options.map(option => {
                            if (item === option.value) {
                                return (React.createElement(S.ActiveTab, { key: item, type: "button", onClick: () => onCheckboxChange(filter.key, item, false, true) },
                                    option.text,
                                    React.createElement(SvgClose, null)));
                            }
                        }))))),
                    sideDropDownFilter?.map((filter) => (activeSideFilter &&
                        activeSideFilter[filter.key] &&
                        activeSideFilter[filter.key]?.map((item) => (filter.options.map(option => {
                            if (item === option.value) {
                                return (React.createElement(S.ActiveTab, { key: item, type: "button", onClick: () => onCheckboxChange(filter.key, item, false, true) },
                                    option.text,
                                    React.createElement(SvgClose, null)));
                            }
                        })))))),
                React.createElement(S.FilterOverflow, null,
                    activeSideFilter && Object.keys(activeSideFilter).length > 0 && (React.createElement(S.ActiveFiltersBase, null,
                        React.createElement(S.ClearBtn, { type: "button", onClick: () => onReset && onReset() }, "Clear filters"))),
                    checkboxFilters.length > 0 && (React.createElement(S.CheckboxFilterHolder, null, checkboxFilters?.map((filter) => (React.createElement(S.FilterHolder, { key: filter.key, animate: activeId === filter.key ? 'open' : 'closed', initial: activeId === filter.key ? 'open' : 'closed' },
                        React.createElement(S.FilterBtn, { type: "button", active: activeId === filter.key, onClick: () => {
                                if (activeId === filter.key) {
                                    setActiveId('');
                                }
                                else {
                                    setActiveId(filter.key ?? '');
                                }
                            } },
                            filter.filterTitle,
                            React.createElement(SvgChevDown, null)),
                        React.createElement(S.FilterOptions, { variants: {
                                open: {
                                    height: 'auto',
                                },
                                closed: {
                                    height: 0,
                                },
                            }, transition: { ease: 'linear', duration: 0.2 } }, filter.options.map((checkbox) => {
                            const selectedOptions = sideDropDownFilterValue[filter.key] ?? [];
                            return (React.createElement(S.Checkbox, { key: checkbox.id },
                                React.createElement(S.ItemContainer, null,
                                    React.createElement(S.CheckboxInput, { type: "checkbox", id: `${filter.key}-${checkbox.value}`, checked: selectedOptions.includes(checkbox.value), name: filter.key, value: checkbox.value, onChange: () => onCheckboxChange(filter.key, checkbox.value) }),
                                    React.createElement(S.CheckboxLabel, { htmlFor: `${filter.key}-${checkbox.value}` },
                                        checkbox.text,
                                        React.createElement(S.Tick, null)))));
                        }))))))),
                    sideDropDownFilter && (React.createElement(React.Fragment, null, sideDropDownFilterValue &&
                        onCheckboxChange &&
                        sideDropDownFilter?.map((filter) => (React.createElement(S.FilterHolder, { key: filter.key, animate: activeId === filter.key ? 'open' : 'closed', initial: activeId === filter.key ? 'open' : 'closed' },
                            React.createElement(S.FilterBtn, { type: "button", active: activeId === filter.key, onClick: () => {
                                    if (activeId === filter.key) {
                                        setActiveId('');
                                    }
                                    else {
                                        setActiveId(filter.key ?? '');
                                    }
                                } },
                                filter.title,
                                React.createElement(SvgChevDown, null)),
                            React.createElement(S.FilterOptions, { variants: {
                                    open: {
                                        height: 'auto',
                                    },
                                    closed: {
                                        height: 0,
                                    },
                                }, transition: { ease: 'linear', duration: 0.2 } }, filter.options.length > 0 && (React.createElement(S.Filter, null,
                                React.createElement(S.SelectLabel, { htmlFor: filter.key },
                                    "Filter by ",
                                    filter.title),
                                React.createElement(S.FilterDropdown, { id: filter.key, name: filter.key, value: sideDropDownFilterValue[filter.key]?.[0] ?? '', onChange: (event) => onCheckboxChange(filter.key, event.target.value, true) },
                                    React.createElement("option", { value: "" }, filter.title),
                                    filter.options.map((option) => (React.createElement("option", { key: option.id, value: option.value }, option.text))))))))))))),
                React.createElement(S.SearchFilterBtnHolder, null,
                    React.createElement(S.FilterSearchBtn, { buttonType: ButtonType.Default, onClick: () => {
                            submitSideFilter(), setSideFilterOpen && setSideFilterOpen(false);
                        }, icon: React.createElement(SvgFilter, null) }, "Show Results")))),
        React.createElement(S.Background, { onClick: (event) => {
                event.preventDefault();
                setSideFilterOpen && setSideFilterOpen(false);
            } })));
};
export default withMotion(SideFilter);
